/**
 * Clearance constants, per PRD §8.1. Shared by every validation rule module
 * so the numbers live in exactly one place.
 */

export const CLEARANCE = {
  /** Round table to round table, chair-back to chair-back, in feet. */
  ROUND_TABLE_TO_ROUND_TABLE_FT: 1.5, // 18 inches
  /** Rectangle table row to rectangle table row, in feet. */
  RECT_ROW_TO_ROW_FT: 5,
  /** Main aisle minimum width, in feet. */
  MAIN_AISLE_FT: 5,
  /** Secondary aisle minimum width, in feet. */
  SECONDARY_AISLE_FT: 3,
  /** Dance floor buffer to nearest table edge, all sides, in feet. */
  DANCE_FLOOR_BUFFER_FT: 4,
  /** DJ booth buffer in front of the booth, in feet. */
  DJ_BOOTH_BUFFER_FT: 3,
  /** Feature zone (cake/gift/dessert/photo booth) buffer radius, in feet. */
  FEATURE_ZONE_BUFFER_FT: 3,
} as const;

/** Object footprint approximations used by clearance checks (table + chairs). */
export const FOOTPRINT = {
  ROUND_TABLE_DIAMETER_FT: 5,
  ROUND_TABLE_WITH_CHAIRS_FT: 9.5,
} as const;
